<template>
  <v-select
      v-model="selfValue"
      dir="rtl"
      :multiple="multiple"
      label="Text"
      :reduce="x => x.Id"
      :options="items"
      :clearable="clearable"
      :loading="loading"
      :selectable="x => unselectable.includes(x.Id) === false || x.Id === val"
      @open="onOpen"
  >
    <span
        slot="no-options"
        @click="$refs.select.open = false"
    >
      {{ $t('common.noOptions') }}
    </span>
    <template #spinner>
      <div class="demo-inline-spacing">
        <b-spinner
            v-if="loading"
            class="m-0"
            small
            variant="secondary"
        />
      </div>
    </template>
  </v-select>
</template>

<script>

import vSelect from 'vue-select'
import { mapState } from 'vuex'

export default {
  name: 'Actions',
  components: {
    vSelect,
  },
  props: {
    value: {
      type: [String, Number, Array],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    unselectable: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      val: '',
      loading: false,
    }
  },
  computed: {
    ...mapState('zirehState', { items: state => state.actionSelect }),
    ...mapState('zirehState', { flag: state => state.actionSelectFlag }),
    selfValue: {
      get() {
        if (this.value && (this.value.length || this.multiple === false)) {
          this.get()
        }
        return this.val
      },
      set(newValue) {
        this.$emit('input', newValue)
        this.val = newValue
      },
    },
    item() {
      let item = this.items.find(i => i.Id === this.selfValue)
       return item || null
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.val = val
      }
    },
    item: {
      immediate: true,
      handler(val) {
        if (val) this.$emit('item', val)
      }
    }
  },
  methods: {
    get() {
      if (this.flag === false && this.items.length === 0) {
        this.$store.commit('zirehState/setActionSelectFlag', true)
        this.loading = true
        this.$http.get(this.$api.declarations.getActions)
            .then(res => {
              let data = res.data

              this.$store.commit('zirehState/setActionSelect', data)
              this.loading = false
            })
      }
    },
    onOpen() {
      this.get()
    },
  },
}
</script>